import angular from "angular";
import template from "./instructor-edit-certification.html";
import InstructorCertificationsController from "./instructor-edit-certification.controller";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.instructor.dashboard.certifications", {
    url: "/certifications",
    controller: InstructorCertificationsController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.instructor,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("instructor.dashboard.certifications", [])
  .config(config)
  .controller(
    "InstructorCertificationsController",
    InstructorCertificationsController,
  );

